// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLoginInput_root__QGQ15","rootdanger":"PlasmicLoginInput_rootdanger__pRZ9X"};